import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
} from 'reactstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../../../../context';

const ConfirmUpdateIsExpeditedModal = ({
    isOpen,
    milestone,
    heading,
    closeBehavior,
}) => {
    const [message, setMessage] = useState('');
    const dispatch = useDispatch();

    const handleInputChange = (event) => {
        setMessage(event.target.value);
    };

    const resetState = () => {
        setMessage('');
    };

    const cancelBehavior = () => {
        resetState();
        closeBehavior();
    };

    const submitBehavior = () => {
        if (heading === 'Trial') {
            dispatch(
                actions.conversions.setTrialExpedited(
                    milestone.id,
                    !milestone.isExpedited,
                    message
                )
            )
                .then(() => {
                    dispatch(actions.toggle.triggerPracticeRefresh());
                    dispatch(actions.toggle.activitiesRefresh());
                })
                .then(() => {
                    resetState();
                    closeBehavior();
                });
        } else if ((heading = 'Final')) {
            dispatch(
                actions.conversions.setFinalExpedited(
                    milestone.id,
                    !milestone.isExpedited,
                    message
                )
            )
                .then(() => {
                    dispatch(actions.toggle.triggerPracticeRefresh());
                    dispatch(actions.toggle.activitiesRefresh());
                })
                .then(() => {
                    resetState();
                    closeBehavior();
                });
        } else {
            closeBehavior();
            throw new Error(`Invalid Conversion Milestone type: ${heading}`);
        }
    };

    return (
        <Modal isOpen={isOpen} centered className="text-light">
            <ModalHeader>{`Confirm Expedite ${heading}`}</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label>Optional Message:</Label>
                        <Input
                            type="textarea"
                            value={message}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="light" onClick={() => cancelBehavior()}>
                    Cancel
                </Button>
                <Button color="primary" onClick={() => submitBehavior()}>
                    Confirm
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ConfirmUpdateIsExpeditedModal;
